/* MOA · VARIANTES SIN PRESELECCIONAR, Y SIN RECARGAR LA PAGINA
   Fichero de MOA-Grafics. NO es del proveedor del tema.

   QUE HACE
   --------
   1. Al entrar en una ficha no hay ninguna opcion elegida, y la foto que se ve
      es la PRIMERA de la galeria -la ilustracion-, no la de ninguna variante.
   2. Los grupos sin resolver parpadean suave. Al elegir uno, ese se queda
      encendido y los demas de su grupo se apagan.
   3. El boton de compra espera hasta que no falta nada por elegir.
   4. **Nada de esto recarga la pagina.** Precio, imagen, formulario y direccion
      se actualizan en vivo.
   5. Al elegir una opcion, la pagina se desplaza suave hasta la foto y aparece
      sobre ella un panel con las otras opciones de ESE grupo, para poder
      comparar sin volver a bajar. El panel se va solo cuando el cliente baja.

   POR QUE NO SE RECARGA, Y ES UNA CORRECCION DE MOU
   -------------------------------------------------
   La primera version recargaba con `?variant=` al completar la eleccion. Era lo
   que hace el tema y garantizaba que precio, imagen y formulario cuadraran.
   Mou lo rechazo el 2026-09-05: *«cuando seleccionas una variante la primera vez
   se actualiza la web, y eso no me gusta para nada»*. Tenia razon: una recarga
   entera para cambiar de talla es un parpadeo de pagina en blanco a media
   compra.

   Asi que ahora se hace a mano, y hay que hacerlo COMPLETO o se rompe algo:

   - `input[name="id"]` del formulario. **Si esto falla, el carrito se lleva la
     variante equivocada.** Paso DOS veces. La segunda, el 2026-09-18, porque
     aqui ponia que este guion «lo comprueba en cada cambio» y no se comprobaba
     en ningun sitio: la variante se escribia en el formulario de pago a plazos
     y al carrito iba siempre la primera. Ahora se comprueba al pulsar comprar
     -la red de seguridad del final del fichero- y **ninguna version se da por
     buena sin esta prueba**: elegir una variante que NO sea la primera del
     producto, añadir al carrito y mirar `/cart.js`.
   - El precio, respetando el formato que ya escribio el tema.
   - La disponibilidad del boton.
   - La imagen: se hace pulsando la miniatura que le toca, en vez de reimplementar
     la galeria. Asi el carrusel, los puntos y el zoom siguen siendo del tema.
   - La direccion, con `replaceState`: quien comparta el enlace comparte lo que
     ve, y quien recargue no pierde su eleccion.

   LO QUE SE RESPETA DEL TEMA
   --------------------------
   No se toca ni un fichero del proveedor. La galeria, el zoom y el carrusel
   siguen siendo suyos: este guion solo pulsa los botones que ya existen. */

(function () {
  'use strict';

  var arranca = function () {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;

    var radios = Array.prototype.slice.call(
      picker.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    var grupos = [];
    radios.forEach(function (r) {
      if (grupos.indexOf(r.name) === -1) grupos.push(r.name);
    });

    /* EL FORMULARIO SE BUSCA DENTRO DE LA FICHA, Y SE ESCRIBEN TODOS.

       Corregido el 2026-09-18. Mou: «cuando añades un poster en el carrito, da
       igual la variante de tamaño que escojas que siempre entrega la medida
       mediana». Reproducido en la tienda publicada: se eligio el XL a 129 € y
       al carrito entro «Blanco / Brillo / 33,3 x 50 cm (Mediano)» a 49 €. Y no
       era solo la medida: Negro / Mate / Pequeño entraba igual, y en un parasol
       se elegia Blanco y entraba Negro. Cero pedidos afectados: se cazo antes.

       La causa era una linea:
       `document.querySelector('form[action*="/cart/add"] input[name="id"]')`
       devuelve el PRIMER formulario de compra de la pagina, y el primero no es
       el de compra: es el de **pago a plazos** de Shopify, que el tema pinta
       antes. La variante elegida se escribia alli y el formulario que va al
       carrito se quedaba con la primera variante del producto. Como este guion
       corta los eventos del selector para que el tema no recargue, nadie mas
       lo corregia.

       Ahora el formulario de compra se toma **del propio boton de compra**
       -`boton.form`, que sigue su atributo `form="ProductForm-..."`- y no del
       orden de la pagina. Se escriben ese y el de pago a plazos de la misma
       seccion, que muestra las cuotas de la variante elegida. Nada mas: si un
       dia vuelve el bloque de accesorios con compra rapida dentro de la ficha,
       sus formularios son de OTRO producto y no se tocan. Los botones son los
       que envian ese mismo formulario: el de la ficha y el de la barra fija que
       aparece al bajar. */
    var seccion = picker.closest('.shopify-section') || document;
    var todosLosAdd = Array.prototype.slice.call(
      seccion.querySelectorAll('button[name="add"]'));
    var boton = todosLosAdd[0] || null;
    var textoOriginal = boton ? boton.innerText.trim() : '';
    var formCompra = boton ? boton.form : null;
    var botones = todosLosAdd.filter(function (b) {
      return formCompra && b.form === formCompra;
    });
    var formularios = [];
    if (formCompra) formularios.push(formCompra);
    Array.prototype.forEach.call(seccion.querySelectorAll('form.installment'),
      function (f) { if (formularios.indexOf(f) === -1) formularios.push(f); });
    // `f.elements` y no `querySelectorAll`: incluye tambien los campos que
    // pertenecen al formulario desde fuera, con el atributo `form`.
    var camposId = [];
    formularios.forEach(function (f) {
      Array.prototype.forEach.call(f.elements, function (c) {
        if (c.name === 'id' && camposId.indexOf(c) === -1) camposId.push(c);
      });
    });
    var nodoPrecio = document.querySelector('.price__regular') ||
                     document.querySelector('.price');
    var plantillaPrecio = nodoPrecio ? nodoPrecio.textContent.trim() : '';

    // --- El catalogo de variantes que el tema deja en la pagina --------------
    var catalogo = null;
    Array.prototype.forEach.call(
      document.querySelectorAll('script[type="application/json"]'),
      function (s) {
        if (catalogo) return;
        try {
          var v = JSON.parse(s.textContent);
          if (Array.isArray(v) && v.length && v[0] && v[0].option1) catalogo = v;
        } catch (e) { /* no era este */ }
      });

    var varianteDe = function (valores) {
      if (!catalogo) return null;
      for (var i = 0; i < catalogo.length; i++) {
        var v = catalogo[i];
        var ops = [v.option1, v.option2, v.option3].filter(Boolean);
        if (ops.length !== valores.length) continue;
        var todas = true;
        for (var j = 0; j < valores.length; j++) {
          if (ops.indexOf(valores[j]) === -1) { todas = false; break; }
        }
        if (todas) return v;
      }
      return null;
    };

    /* La primera variante que encaja con lo elegido HASTA AHORA, aunque falten
       grupos. Sirve solo para saber que foto enseñar mientras el cliente decide;
       nunca para el precio ni para el formulario. */
    var varianteParcial = function (valores) {
      if (!catalogo || !valores.length) return null;
      for (var i = 0; i < catalogo.length; i++) {
        var v = catalogo[i];
        var ops = [v.option1, v.option2, v.option3].filter(Boolean);
        var todas = true;
        for (var j = 0; j < valores.length; j++) {
          if (ops.indexOf(valores[j]) === -1) { todas = false; break; }
        }
        if (todas) return v;
      }
      return null;
    };

    // --- La galeria: se maneja pulsando las miniaturas del tema --------------
    var soloNombre = function (url) {
      return (url || '').split('?')[0].split('/').pop();
    };
    var miniaturas = Array.prototype.slice.call(
      document.querySelectorAll('.product__thumbnail'));
    var medios = Array.prototype.slice.call(
      document.querySelectorAll('.product__media-list > *'));
    var ficheroDeMedio = {};
    medios.forEach(function (m) {
      var img = m.querySelector('img');
      if (img && m.dataset.mediaId) {
        ficheroDeMedio[m.dataset.mediaId] = soloNombre(img.currentSrc || img.src);
      }
    });
    /* Llevar el carrusel a una foto concreta.

       Se pulsa la miniatura Y ADEMAS se desplaza a mano. Lo segundo no sobra:
       probado el 2026-09-05, en movil el clic en la miniatura no mueve el
       carrusel -el scroll se quedaba en 0-. El clic se mantiene porque es lo que
       marca la miniatura activa y avisa al tema. */
    /* El carrusel NO lo mueve `.product__media-list`: esa capa esta en
       `overflow-x: visible`. El que desplaza es un padre suyo -el
       `slider-element` del tema-. Medido el 2026-09-05: desplazando la lista, el
       scroll se quedaba en 0 y la foto no cambiaba. Se busca hacia arriba el
       primero que de verdad tenga desbordamiento horizontal. */
    /* **No basta con que el elemento desborde: tiene que desplazarse.**
       `.product__media-list` mide 1067 de contenido en 353 de caja y aun asi no
       es el que scrollea, porque esta en `overflow-x: visible`. El que manda es
       su padre `slider-element`, en `auto`. Costo tres intentos el 2026-09-05:
       el primer buscador devolvia la lista y el desplazamiento no hacia nada. */
    var carrusel = function () {
      var n = document.querySelector('.product__media-list');
      while (n && n !== document.body) {
        var ov = getComputedStyle(n).overflowX;
        if ((ov === 'auto' || ov === 'scroll') && n.scrollWidth > n.clientWidth + 4) {
          return n;
        }
        n = n.parentElement;
      }
      return null;
    };

    /* El deslizador del tema expone `select(n)`. Se usa el suyo antes que mover
       el scroll a mano: asi el tema se entera del cambio y actualiza sus puntos,
       sus botones y la altura. El desplazamiento queda de reserva.

       **`select` CUENTA DESDE 1, no desde 0.** Medido el 2026-09-05 llamandolo
       con 0, 1 y 2 sobre una galeria de tres: 0 y 1 daban la primera foto y 2
       daba la segunda. Sin esto la imagen iba siempre una por detras de la
       variante elegida, que es peor que no moverla. */
    var irAIndice = function (idx) {
      var c = carrusel();
      var lista = document.querySelector('.product__media-list');
      var medio = lista ? lista.children[idx] : null;

      /* Si no hay carrusel no se hace NADA, y menos desplazar la pagina.

         Historia corta: el 2026-09-05 la galeria de escritorio era una columna
         con las seis fotos apiladas, no habia nada que deslizar, y se puso un
         desplazamiento hasta la foto que tocara. **Mou lo rechazo el mismo dia**
         —*«en ordenador, si cambio de variante, no tiene que hacer
         desplazamiento, no hace falta»*— y en su lugar se cambio la galeria de
         escritorio a imagen grande con miniaturas, que es un ajuste del tema.

         Asi que este caso ya no deberia darse. Se deja el guardia por si alguien
         vuelve a poner la galeria en columna: entonces no pasa nada, que es
         mejor que mover la pagina sola. */
      if (!c) return;

      var slider = lista ? lista.closest('slider-element') : null;
      if (slider && typeof slider.select === 'function') {
        try { slider.select(idx + 1); return; } catch (e) { /* seguimos abajo */ }
      }
      if (medio) c.scrollTo({ left: medio.offsetLeft, behavior: 'smooth' });
    };

    var irAImagen = function (src) {
      var quiero = soloNombre(src);
      var lista = document.querySelector('.product__media-list');
      if (!lista) return false;
      for (var i = 0; i < lista.children.length; i++) {
        var id = lista.children[i].dataset.mediaId;
        if (ficheroDeMedio[id] !== quiero) continue;
        for (var j = 0; j < miniaturas.length; j++) {
          if (miniaturas[j].dataset.mediaId === id) { miniaturas[j].click(); break; }
        }
        irAIndice(i);
        return true;
      }
      return false;
    };

    // --- El panel flotante sobre la foto ------------------------------------
    var galeria = document.querySelector('.product__media-container');
    var panel = null;
    var grupoEnPanel = null;

    var montarPanel = function (nombreGrupo) {
      if (!galeria) return;
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'moa-panel-variantes';
        panel.setAttribute('aria-hidden', 'true');
        galeria.style.position = galeria.style.position || 'relative';
        galeria.appendChild(panel);
      }
      grupoEnPanel = nombreGrupo;
      var del = radios.filter(function (r) { return r.name === nombreGrupo; });
      panel.innerHTML = '';
      panel.setAttribute('data-cuantos', String(del.length));
      del.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'moa-panel-boton' + (r.checked ? ' moa-panel-boton--puesto' : '');
        b.textContent = r.value;
        b.addEventListener('click', function () { elegir(r); });
        panel.appendChild(b);
      });
    };

    var mostrarPanel = function () { if (panel) panel.classList.add('moa-visible'); };
    var ocultarPanel = function () { if (panel) panel.classList.remove('moa-visible'); };

    // El panel se va cuando la foto deja de verse: el cliente ha bajado y ya
    // esta mirando otra cosa. Volver a enseñarlo ahi seria estorbar.
    if ('IntersectionObserver' in window && galeria) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { if (!e.isIntersecting) ocultarPanel(); });
      }, { threshold: 0.35 }).observe(galeria);
    }

    // --- Aplicar una variante, entera ---------------------------------------
    var aplicar = function (v) {
      /* COMBINACION QUE NO EXISTE: NO SE COMPRA. Antes se salia sin tocar nada
         y el formulario se quedaba con la ultima variante valida, que es lo
         que habria ido al carrito. Hoy ningun producto activo tiene la rejilla
         de variantes incompleta; pasara el dia que se borre una suelta. */
      if (!v) {
        botones.forEach(function (b) { b.disabled = true; });
        if (boton) boton.innerText = 'No disponible';
        return;
      }
      camposId.forEach(function (c) { c.value = v.id; });

      if (nodoPrecio && typeof v.price === 'number') {
        var n = (v.price / 100).toFixed(2).replace('.', ',');
        nodoPrecio.textContent = plantillaPrecio.replace(/[\d.,]+/, n);
      }
      /* Los DOS botones siguen la disponibilidad, y el texto se repone aqui:
         `repintar` corre antes que esto y ve el boton aun desactivado por la
         espera, asi que no puede devolverle su texto. */
      botones.forEach(function (b) { b.disabled = !v.available; });
      if (boton) boton.innerText = v.available ? textoOriginal : 'Agotado';
      if (v.featured_image && v.featured_image.src) irAImagen(v.featured_image.src);

      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      } catch (e) { /* da igual, es un adorno */ }
    };

    // --- Pintado del estado --------------------------------------------------
    var aviso = null;
    var datos = document.getElementById('moa-variantes-datos');
    var textoAviso = datos ? (datos.getAttribute('data-aviso') || '').trim() : '';
    if (textoAviso && nodoPrecio && nodoPrecio.parentElement) {
      aviso = document.createElement('p');
      aviso.className = 'moa-aviso-precio';
      aviso.textContent = textoAviso;
      nodoPrecio.parentElement.appendChild(aviso);
    }

    /* LA CABECERA SE COMPONE, NO SE PARCHEA CON UNA EXPRESION REGULAR.

       Corregido el 2026-09-07 despues de verlo en la ficha del Martini: la
       cabecera decia **«Tamaño: 46,7 x 70 cm (Grande)46,7 x 70 cm (Grande)»**,
       con el valor escrito dos veces.

       La version anterior guardaba el HTML de la cabecera y le hacia
       `replace(/>[^<>]*$/, '>' + valor)`, dando por hecho que terminaba en texto
       suelto detras de un `>`. Y no siempre: **cuando el tema ya habia pintado un
       valor, la cabecera termina en `</span>`**, asi que la expresion casaba con
       ese cierre y el valor nuevo se pegaba FUERA del span, detras del que ya
       habia. Pasaba justo en el grupo Tamaño, que es el unico que el tema pinta
       resuelto de salida porque su primera variante manda.

       Y al reves, en Color y Acabado la cabecera es solo la palabra, sin ningun
       `>`: la expresion no casaba con nada y **el valor elegido no llegaba a
       verse nunca**.

       Ahora se guardan las piezas -la caja, el nombre y el span del tema si lo
       hay- y se compone «Nombre: valor» cada vez. El span se reutiliza, con su
       identificador y su clase, para no perder lo que el tema cuelgue de el. */
    var cabeceras = {};
    grupos.forEach(function (g) {
      var uno = null;
      radios.forEach(function (r) { if (!uno && r.name === g) uno = r; });
      var fs = uno.closest('fieldset');
      if (!fs) return;
      var cab = fs.querySelector('.form__label > div');
      if (!cab) return;
      var leyenda = fs.querySelector('legend');
      cabeceras[g] = {
        caja: cab, span: cab.querySelector('span'),
        nombre: leyenda ? leyenda.textContent.trim() : ''
      };
    });

    var pendientesDe = function () {
      var n = 0;
      grupos.forEach(function (g) {
        var hay = false;
        radios.forEach(function (r) { if (r.name === g && r.checked) hay = true; });
        if (!hay) n++;
      });
      return n;
    };

    var repintar = function () {
      var pendientes = 0;
      grupos.forEach(function (g) {
        var elegido = null;
        radios.forEach(function (r) { if (r.name === g && r.checked) elegido = r; });
        if (!elegido) pendientes++;

        var c = cabeceras[g];
        if (c) {
          if (elegido) {
            if (!c.span) {
              c.span = document.createElement('span');
              c.span.className = 'font-medium';
            }
            c.span.textContent = elegido.value;
            // Vaciar la caja se lleva por delante al span, pero el nodo sigue
            // siendo nuestro: se vuelve a colgar detras del nombre.
            c.caja.textContent = c.nombre + ': ';
            c.caja.appendChild(c.span);
          } else {
            c.caja.textContent = c.nombre;
          }
        }
        radios.forEach(function (r) {
          if (r.name !== g) return;
          var caja = r.closest('magnet-element') || r.parentElement;
          if (!caja) return;
          caja.classList.toggle('moa-parpadea', !elegido);
          caja.classList.toggle('moa-apagado', !!elegido && !r.checked);
        });
      });

      if (boton) {
        boton.classList.toggle('moa-bloqueado', pendientes > 0);
        if (pendientes > 0) boton.innerText = 'Elige tus opciones';
        else if (!boton.disabled) boton.innerText = textoOriginal;
      }
      /* MIENTRAS FALTE ALGO POR ELEGIR, EL BOTON PRINCIPAL QUEDA DESACTIVADO DE
         VERDAD. Hasta el 2026-09-18 solo se le quitaba el raton con CSS, y el
         teclado y la tecla Intro en la cantidad seguian enviando el formulario
         con la primera variante dentro. Desactivado el principal, el Intro ya
         no envia: es el boton por defecto del formulario.

         El de la barra fija NO se desactiva: saldria gris sin decir por que.
         Se queda activo y, si falta algo, `sincronizar` corta la compra y lleva
         al cliente hasta las opciones. Al completar la eleccion, `aplicar`
         reactiva el principal segun disponibilidad. */
      if (boton && pendientes > 0) boton.disabled = true;
      if (aviso) aviso.hidden = pendientes === 0;

      if (panel && grupoEnPanel) {
        /* `botonesPanel`, y NO `botones`: con `var`, un `botones` aqui tapa en
           toda esta funcion a los botones de compra de fuera y el guion
           revienta al arrancar. Paso en el primer parche del 2026-09-18 y lo
           cazo la revision antes de subirlo. */
        var botonesPanel = panel.querySelectorAll('.moa-panel-boton');
        var del = radios.filter(function (r) { return r.name === grupoEnPanel; });
        for (var i = 0; i < botonesPanel.length && i < del.length; i++) {
          botonesPanel[i].classList.toggle('moa-panel-boton--puesto', del[i].checked);
        }
      }
      return pendientes;
    };

    // --- Elegir un valor -----------------------------------------------------
    var elegir = function (input) {
      radios.forEach(function (r) { if (r.name === input.name) r.checked = false; });
      input.checked = true;
      repintar();

      var valores = [];
      radios.forEach(function (r) { if (r.checked) valores.push(r.value); });

      if (pendientesDe() === 0) {
        aplicar(varianteDe(valores));
      } else {
        /* LA FOTO CAMBIA EN CUANTO SE ELIGE EL COLOR, aunque falte el acabado.

           Este era el fallo que Mou describia como «cambio de variante y me
           mantiene la imagen», el 2026-09-05. La primera version solo cambiaba
           la foto al completar la eleccion entera, y como ya no hay ninguna
           opcion preseleccionada, elegir un color no hacia nada visible: habia
           que acertar tambien con el acabado para que pasara algo. Desde fuera
           eso es exactamente «no funciona».

           La imagen depende del COLOR, no del acabado ni del Instagram. Asi que
           en cuanto lo elegido basta para saber que foto toca, se enseña. El
           precio y el formulario NO se tocan aqui: esos si necesitan la variante
           entera, y tocarlos a medias es lo que pondria en el carrito algo que
           el cliente no ha elegido. */
        var parcial = varianteParcial(valores);
        if (parcial && parcial.featured_image && parcial.featured_image.src) {
          irAImagen(parcial.featured_image.src);
        }

        /* EL PRECIO CAMBIA EN CUANTO LO ELEGIDO YA LO DECIDE.

           Mou, 2026-09-17: «si no seleccionamos primero la variante de brillo o
           mate no se modifica el precio en funcion del tamaño (...) quiero que
           aparezca el precio de variante de tamaño aunque la de acabado no
           este seleccionada».

           Se mira que precio tienen TODAS las variantes que encajan con lo
           elegido hasta ahora. Si todas coinciden -en un poster el precio va
           por tamaño, brillo y mate valen lo mismo-, ese precio se enseña. Si
           no coinciden -solo se ha elegido el acabado y cada tamaño vale
           distinto-, no se toca. El formulario, el boton y la direccion siguen
           esperando a la variante entera: eso es lo que evita un pedido mal
           servido, y no cambia. */
        if (catalogo && nodoPrecio) {
          var precios = [];
          catalogo.forEach(function (v) {
            var ops = [v.option1, v.option2, v.option3].filter(Boolean);
            var encaja = true;
            for (var k = 0; k < valores.length; k++) {
              if (ops.indexOf(valores[k]) === -1) { encaja = false; break; }
            }
            if (encaja && typeof v.price === 'number' && precios.indexOf(v.price) === -1) {
              precios.push(v.price);
            }
          });
          if (precios.length === 1) {
            nodoPrecio.textContent = plantillaPrecio.replace(
              /[\d.,]+/, (precios[0] / 100).toFixed(2).replace('.', ','));
          }
        }
      }

      /* EL PANEL Y EL DESPLAZAMIENTO SON SOLO DE MOVIL, y se decide por el
         ancho de pantalla, no por si hay carrusel.

         Estuvo mal atado un rato: la condicion miraba si habia carrusel, y
         cuando el 2026-09-05 se puso tambien en escritorio la galeria de imagen
         grande con miniaturas, el escritorio paso a tener carrusel y se llevo de
         propina las dos cosas. **Mou habia pedido justo lo contrario**: *«en
         ordenador, si cambio de variante, no tiene que hacer desplazamiento, no
         hace falta»*.

         El motivo de fondo: en el movil las opciones estan debajo del pliegue y
         hay que subir para ver la foto; en un escritorio de 1440 px la foto y
         las opciones se ven a la vez. Mover la pagina ahi es un tiron gratuito. */
      if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) {
        montarPanel(input.name);
        if (galeria) {
          galeria.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(mostrarPanel, 420);
        }
      }
    };

    /* LAS MEDIDAS SE ORDENAN DE MAYOR A MENOR, Y SOLO EN PANTALLA.

       Mou el 2026-09-05: «las variantes se ordenaran de mas grande a mas
       pequeño». En la ficha salian Grande, XL, Mediano, Pequeño, que se lee mal.

       Aqui decia que «la API no deja reordenar los valores de una opcion» y
       era FALSO: `productOptionsReorder` existe y reordena sin renombrar.
       Corregido el 2026-09-17, cuando Mou pidio que el precio de salida del
       poster fuera el del mediano: eso se hizo en Shopify, reordenando los
       valores de Tamaño con `scripts/apply_orden_poster.py` para que la
       PRIMERA variante -la que da el precio de salida- sea la de 33,3 x 50.

       El orden en Shopify (mediano, grande, XL, pequeño) sirve al precio de
       salida; el orden en pantalla sigue siendo de mayor a menor y lo pone
       este bloque. Son dos cosas distintas y las dos son deliberadas.

       Se ordena solo si TODOS los valores del grupo llevan medida. Un grupo de
       colores o de acabados se queda como esta. */
    var medidaDe = function (texto) {
      var m = (texto || '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
      if (!m) return null;
      var a = parseFloat(m[1].replace(',', '.'));
      var b = parseFloat(m[2].replace(',', '.'));
      return (isNaN(a) || isNaN(b)) ? null : a * b;
    };

    grupos.forEach(function (g) {
      var cajas = [];
      var todasConMedida = true;
      radios.forEach(function (r) {
        if (r.name !== g) return;
        var caja = r.closest('magnet-element') || r.parentElement;
        var area = medidaDe(r.value);
        if (area === null) todasConMedida = false;
        cajas.push({ caja: caja, area: area });
      });
      if (!todasConMedida || cajas.length < 2) return;
      var padre = cajas[0].caja.parentElement;
      if (!padre) return;
      cajas.sort(function (a, b) { return b.area - a.area; });
      cajas.forEach(function (c) { padre.appendChild(c.caja); });
    });

    /* Y LA LISTA DE RADIOS SE REORDENA CON LA PANTALLA. NO SOBRA.

       Corregido el 2026-09-07. Mou: «el despliegue de las variantes sigue
       apareciendo primero la de grande, cuando realmente empieza por xl y luego
       grande luego mediano y luego pequeño».

       Reproducido en la ficha del Schumacher a 390 px: los botones de la ficha
       salian bien -XL, Grande, Mediano, Pequeño- y el panel que aparece sobre la
       foto salia con Grande delante.

       El motivo es que `radios` se lee del DOM al arrancar y **mover los nodos no
       reordena un array ya construido**. El bloque de arriba coloca bien la
       pantalla, pero `montarPanel` y `repintar` siguen recorriendo el array
       viejo: uno pinta los botones del panel y el otro empareja cada boton con
       su radio por posicion, asi que desordenados fallarian los dos.

       Se ordena por posicion en el documento, que es la unica fuente de verdad
       una vez movidos los nodos, en vez de repetir aqui el criterio de la
       medida. Si un grupo no se ordena -colores, acabados- se queda como estaba,
       porque su posicion en el DOM no ha cambiado. */
    radios.sort(function (a, b) {
      var rel = a.compareDocumentPosition(b);
      if (rel & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (rel & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });

    // --- Arranque ------------------------------------------------------------
    var yaEligio = new URLSearchParams(location.search).has('variant');
    if (!yaEligio) {
      radios.forEach(function (r) { r.checked = false; });

      /* LA PORTADA ES LA PRIMERA FOTO QUE NO ES DE NINGUNA VARIANTE.

         No vale con pulsar la primera miniatura: **el tema mueve al principio de
         la galeria la foto de la variante seleccionada**, y sin `?variant=` esa
         es la primera variante del producto. Medido el 2026-09-05 en la ficha
         del Schumacher: la tienda tiene el orden ilustracion, grande, mediano, y
         el navegador pintaba mediano, ilustracion, grande.

         **La portada la dice la propia ficha, no la adivina este guion.** Viene
         en `data-portada` desde la plantilla, y es `product.media[0]`: la
         primera imagen de la galeria tal como Mou la ha ordenado en el panel.
         En un parasol eso es el coche con el parasol puesto; en un poster, la
         ilustracion.

         La primera version lo adivinaba -«la primera foto que no cuelga de
         ninguna variante»- y en parasoles daba el vinilo suelto, porque ahi son
         justo las fotos de coche las que cuelgan de las variantes. Mou lo vio el
         2026-09-05. **Adivinar el orden estaba mal de raiz: el orden es una
         decision suya, no una regla que deba vivir en el codigo.**

         Y se MUEVE el nodo en vez de pulsar su miniatura: probado en vivo,
         pulsar la miniatura no desplaza el carrusel en movil. Moviendo el nodo,
         y su miniatura con el, el carrusel, los puntos y el zoom siguen
         cuadrando porque para el tema el orden es el que ve en el DOM. */
      /* NO BASTA CON LA PORTADA: SE REPONE LA GALERIA ENTERA.

         Corregido el 2026-09-06. Mou: «en todas las demas, es ilustracion y
         empieza con el poster grande en vez del xl». Medido en la pagina
         servida del casco de Senna: en Shopify el orden es ilustracion, XL,
         grande, y **el HTML llegaba con el grande delante de todo**. Moviendo
         solo la portada quedaba ilustracion, grande, XL: la portada bien y el
         resto al reves.

         El motivo es el mismo de siempre —el tema adelanta la foto de la
         variante activa— pero la variante activa por defecto **no es la que
         parece**: es la primera del producto, y en poster los valores de la
         opcion Tamaño empiezan por «46,7 x 70 cm (Grande)», no por el XL.
         Reordenar esos valores en Shopify no se puede por API, asi que el orden
         se repone aqui.

         `data-orden` trae la galeria entera desde la plantilla, en el orden de
         Shopify. Se recolocan lista y miniaturas siguiendolo. */
      var lista = document.querySelector('.product__media-list');
      var tiras = document.querySelector('.product__thumbnails-list');
      var idPortada = datos ? (datos.getAttribute('data-portada') || '').trim() : '';
      var orden = (datos ? (datos.getAttribute('data-orden') || '') : '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      var recolocar = function (caja) {
        if (!caja || !orden.length) return;
        var ancla = null;   // se va empujando cada nodo detras del anterior
        orden.forEach(function (id) {
          var nodo = caja.querySelector('[data-media-id="' + id + '"]');
          if (!nodo) return;   // la galeria puede tener menos de lo que dice el orden
          if (ancla) { if (nodo.previousElementSibling !== ancla) caja.insertBefore(nodo, ancla.nextSibling); }
          else if (nodo !== caja.firstElementChild) { caja.insertBefore(nodo, caja.firstElementChild); }
          ancla = nodo;
        });
      };

      if (orden.length) {
        recolocar(lista);
        recolocar(tiras);
        irAIndice(0);
      } else {
        /* Sin `data-orden` -una ficha con la seccion antigua- se hace lo de
           antes: al menos la portada delante. */
        if (idPortada && lista && !lista.querySelector('[data-media-id="' + idPortada + '"]')) {
          idPortada = null;   // esa imagen no esta en la galeria: no se inventa nada
        }
        if (idPortada && lista) {
          var medio = lista.querySelector('[data-media-id="' + idPortada + '"]');
          if (medio && medio !== lista.firstElementChild) {
            lista.insertBefore(medio, lista.firstElementChild);
          }
          if (tiras) {
            var mini = tiras.querySelector('[data-media-id="' + idPortada + '"]');
            if (mini && mini !== tiras.firstElementChild) {
              tiras.insertBefore(mini, tiras.firstElementChild);
            }
          }
          irAIndice(0);
        }
      }
    }
    repintar();

    // El clic sobre una etiqueta lo gestionamos nosotros de principio a fin: si
    // se deja pasar, el selector del tema recarga la pagina, que es justo lo que
    // Mou no quiere.
    /* SE INTERCEPTAN LOS DOS EVENTOS, Y NO ES REDUNDANTE.

       Con raton funcionaba interceptando solo el `click`. **En el iPhone de Mou
       no**: tocaba una variante y la foto no cambiaba, aunque en el emulador si.
       El motivo es el orden de los eventos: al tocar la etiqueta, el navegador
       marca el radio y dispara `change` ANTES de que llegue el `click`, asi que
       el selector del tema ya habia hecho lo suyo cuando nosotros
       intervenamos. Un clic sintetico en el emulador no reproduce ese orden, y
       por eso la prueba daba bien y el movil real daba mal.

       La bandera evita la vuelta: `elegir` marca radios, y aunque asignar
       `checked` no dispara `change`, mas vale no depender de eso. */
    var dentro = false;

    var interceptar = function (input, ev) {
      if (!input || input.type !== 'radio') return;
      if (ev.cancelable) ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      if (dentro) return;
      dentro = true;
      try { elegir(input); } finally { dentro = false; }
    };

    picker.addEventListener('change', function (ev) {
      interceptar(ev.target, ev);
    }, true);

    picker.addEventListener('click', function (ev) {
      var label = ev.target.closest('label');
      if (!label) return;
      var input = label.control ||
        (label.htmlFor ? document.getElementById(label.htmlFor) : null);
      interceptar(input, ev);
    }, true);

    /* RED DE SEGURIDAD: AL PULSAR COMPRAR, LA VARIANTE SE VUELVE A ESCRIBIR A
       PARTIR DE LO QUE ESTA MARCADO.

       Añadida el 2026-09-18 con el arreglo del principio. El fallo del carrito
       paso porque la variante se escribia en un sitio y se enviaba otro, y
       nadie lo comprobaba. Ahora se comprueba en el unico momento que importa:
       el de comprar. Si falta algo por elegir, no se compra. Si esta todo, los
       campos de variante de la ficha se igualan a la variante marcada ANTES de
       que el tema lea el formulario.

       Se escucha en fase de captura, para ir por delante de cualquier otro
       guion, y por las dos vias: el clic en los botones y el envio del
       formulario. El tema puede comprar por cualquiera de las dos. */
    var cortar = function (ev) {
      if (ev.cancelable) ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    };

    var sincronizar = function (ev) {
      if (pendientesDe() > 0) {
        cortar(ev);
        repintar();
        // Sobre todo para la barra fija: el cliente esta abajo y las opciones
        // arriba. Se le lleva hasta ellas en vez de no hacer nada.
        try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        return;
      }
      var valores = [];
      radios.forEach(function (r) { if (r.checked) valores.push(r.value); });
      var v = varianteDe(valores);
      if (!v) { cortar(ev); aplicar(null); return; }
      camposId.forEach(function (c) { c.value = v.id; });
    };

    seccion.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('button[name="add"]') : null;
      if (b && botones.indexOf(b) !== -1) sincronizar(ev);
    }, true);

    formularios.forEach(function (f) {
      f.addEventListener('submit', sincronizar, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
